<h2 mat-dialog-title>Seleccione Nuevo Trabajo</h2>
@if (!works) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <span>Esperando respuesta del servidor</span>
} @else {
  <mat-dialog-content>
    <div class="buttons">
      @for(work of works; track work.id){
        <button mat-button (click)="setWork(work)" class="primary">{{work.name}}</button>
      }
    </div>
  </mat-dialog-content>
}